/**
 * Converts an number to a compact number if value grows larger.
 * Example: 1500 will become 1.5k, and 2413 will become 2.4k etc
 * @constructor
 * @param {number} value - The number we want to convert
 */
export const abbreviateNumber = (value: number, threshold = 1000): string => {
  let newValue = value.toString();

  if (value >= threshold) {
    const suffixes = ['', 'k', 'm', 'b', 't', 'q'];
    const suffixNum = Math.floor(`${value}`.length / 3);

    let shortValue;

    for (let precision = 2; precision >= 1; precision -= 1) {
      shortValue = parseFloat(
        (suffixNum !== 0 ? value / 1000 ** suffixNum : value).toPrecision(
          precision,
        ),
      );
      const dotLessShortValue = `${shortValue}`.replace(/[^a-zA-Z 0-9]+/g, '');

      if (dotLessShortValue.length <= 2) {
        break;
      }
    }
    if (shortValue % 1 !== 0) {
      shortValue = shortValue.toFixed(1);
    }
    newValue = shortValue + suffixes[suffixNum];
  }

  return newValue;
};
